import { DefaultTheme } from "styled-components";

export const theme: DefaultTheme = {
  colors: {
    primaryColor: "#2789B3",
    white: "#FFFFFF",
    black: "#000000",
    gray: "#C4C4C4",
    darkGray: "#707070",
    mediumGray: "#484848",
    lightGray: "#E8E8E8",
    placeholderGray: "#B2B2B2",
    disabledGray: "#707070",
    lightBlue: "#EBFAFF",
    mediumBlue: "#2789B3",
    darkBlue: "#1D5A80",
    yellow: "#F9CB17",
    vividBlue: "#35BDE8",
    aquaBlue: "#00DAFF",
    red: "#FF5D50",
    green: "#69D894",
    lightGreen: "#86FF9D",
    darkGreen: "#219653",
    lightRed: "#FF8F86",
    orange: "#FFA500",
    transparent: "transparent",
    veryLightBlue: "#CFEFFA",
    deepDarkBlue: "#17415A",
    /* Paleta do design de Alertas (XD) */
    amber: "#FF9D00",
    lightAmber: "#FFC74A",
    brightYellow: "#FFD800",
    cyan: "#03A8D3",
    pageGray: "#EFF1F2",
    ink: "#1D1D1D",
    dividerGray: "#E6E6E6",
  },

  fonts: {
    primary: "Nunito",
    secondary: "Nunito",
  },

  fontSizes: {
    xxs: "0.5rem", // 8px (raiz 16px)
    xs: "0.7rem", // ~11px
    sm: "0.9rem", // ~14px
    md: "1.2rem", // ~19px
    lg: "1.45rem", // ~23px
    xl: "2rem", // 32px
    xl2: "2.7rem", // ~43px
    xxl: "3rem", // 48px
  },

  fontWeights: {
    extraLight: 100,
    light: 300,
    normal: 400,
    medium: 500,
    semiBold: 600,
    bold: 700,
  },

  breakpoints: {
    xs: "0px", // Extra small - Telas menores que 640px (smartphones)
    sm: "640px", // Small - Telas maiores que 640px (tablets)
    md: "768px", // Medium - Telas maiores que 768px (desktops)
    lg: "1024px", // Large  - Telas maiores que 1024px (desktops)
    xl: "1280px", // Extra large - Telas maiores que 1280px (desktops)
    xxl: "1536px", // 2x Extra large - Telas maiores que 1536px (desktops)
  },

  borderRadius: {
    none: "0",
    small: "0.25rem", // 4px
    medium: "0.5rem", // 8px
    large: "0.75rem", // 12px
    extraLarge: "1.2rem", // 16px
    full: "999px", // Círculos
  },

  shadows: {
    light: {
      small: "0px 1px 3px rgba(0, 0, 0, 0.1)",
      medium: "0px 3px 6px rgba(0, 0, 0, 0.15)",
      large: "0px 5px 10px rgba(0, 0, 0, 0.2)",
    },
    dark: {
      small: "0px 1px 3px rgba(0, 0, 0, 0.3)",
      medium: "0px 3px 6px rgba(0, 0, 0, 0.4)",
      large: "0px 5px 10px rgba(0, 0, 0, 0.5)",
    },
    colorful: {
      blue: "3px 4px 8px rgba(53, 189, 232, 0.5)", // Azul vivo
      yellow: "3px 4px 8px rgba(249, 203, 23, 0.5)", // Amarelo
      red: "3px 4px 8px rgba(255, 93, 80, 0.5)", // Vermelho
    },
  },

  spacing: (factor: number) => `${factor * 0.4}rem`,
};
